import { Link } from "react-router-dom";
import samboardsLogo from "@/assets/samboards-logo.png";
import disabilityConfidentBadge from "@/assets/disability-confident-badge.png";
import fsbMemberBadge from "@/assets/fsb-member-badge.png";
import madeInBritainBadge from "@/assets/made-in-britain-badge.png";
import medilinkFinalistBadge from "@/assets/medilink-finalist-2025.png";
import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";
import { SiTiktok } from "react-icons/si";
export const Footer = () => {
  return <footer className="mt-16 w-full max-w-7xl mx-auto px-4 md:px-8 py-10 bg-slate-900 border-t border-slate-700">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img src={samboardsLogo} alt="Samboards - Premium sensory boards for neurodivergent minds" width="591" height="344" className="h-10 w-auto" loading="eager" />
            <p className="text-sm text-slate-300 leading-relaxed">
              Premium sensory boards designed in the UK for neurodivergent minds.
            </p>
            <div className="mt-6 flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
              <a href="https://www.gov.uk/government/publications/disability-confident-guidance-for-levels-1-2-and-3/level-1-disability-confident-committed" target="_blank" rel="noopener noreferrer" className="inline-block transition-opacity hover:opacity-80" aria-label="Learn more about Disability Confident Committed">
                <img src={disabilityConfidentBadge} alt="Disability Confident Committed badge" width="480" height="231" className="h-12 w-auto object-contain" />
              </a>
              <a href="https://www.fsb.org.uk/membership" target="_blank" rel="noopener noreferrer" className="inline-block transition-opacity hover:opacity-80" aria-label="Learn more about FSB membership">
                <img src={fsbMemberBadge} alt="Federation of Small Businesses member badge" width="286" height="180" className="h-10 w-auto object-contain" />
              </a>
              <a href="https://www.madeinbritain.org/" target="_blank" rel="noopener noreferrer" className="inline-block transition-opacity hover:opacity-80" aria-label="Learn more about Made in Britain">
                <img src={madeInBritainBadge} alt="Made in Britain badge" width="203" height="248" className="h-12 w-auto object-contain" />
              </a>
            </div>
            <div className="flex gap-4 mt-4">
              <a href="https://www.facebook.com/Samboards-Ltd-106486107414870/" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-emerald-400 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 rounded p-2" aria-label="Samboards on Facebook">
                <Facebook size={20} aria-hidden="true" />
              </a>
              <a href="https://twitter.com/samboards" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-emerald-400 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 rounded p-2" aria-label="Samboards on X (Twitter)">
                <Twitter size={20} aria-hidden="true" />
              </a>
              <a href="https://www.instagram.com/samboardsltd/" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-emerald-400 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 rounded p-2" aria-label="Samboards on Instagram">
                <Instagram size={20} aria-hidden="true" />
              </a>
              <a href="https://www.youtube.com/channel/UC5gosggcOP74x5gPlH1P4zg" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-emerald-400 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 rounded p-2" aria-label="Samboards on YouTube">
                <Youtube size={20} aria-hidden="true" />
              </a>
              <a href="https://www.tiktok.com/@officialsamboardsltd" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-emerald-400 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 rounded p-2" aria-label="Samboards on TikTok">
                <SiTiktok size={20} aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <p className="font-semibold text-slate-100 mb-4">Products</p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/samboards" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Samboards
                </Link>
              </li>
              <li>
                <Link to="/satpin" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Satpin Board
                </Link>
              </li>
              <li>
                <Link to="/sensory-pads" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Sensory Pads
                </Link>
              </li>
              <li>
                <Link to="/library-squares" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Library Squares
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Shop All Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <p className="font-semibold text-slate-100 mb-4">Company</p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/order-tracking" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Track order
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/professionals" className="text-slate-300 hover:text-emerald-400 transition-colors">
                  For Professionals
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-slate-100 mb-4">Get in Touch</p>
            <p className="text-sm text-slate-300 leading-relaxed">
              Email us with any questions or inquiries about our sensory products.
            </p>
            <Link to="/contact" className="inline-block mt-4 text-sm font-medium text-emerald-400 hover:underline">
              Contact Us →
          </Link>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-slate-700">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-sm text-slate-300 text-center md:text-left">
              © {new Date().getFullYear()} Samboards Ltd. All rights reserved. UK-designed sensory boards for neurodivergent minds.
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-xs text-slate-400">
              <Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors">
                Privacy Policy
              </Link>
              <span>•</span>
              <Link to="/terms-of-service" className="hover:text-emerald-400 transition-colors">
                Terms of Service
              </Link>
              <span>•</span>
              <Link to="/cookie-policy" className="hover:text-emerald-400 transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
          <img src={medilinkFinalistBadge} alt="Medilink UK Finalist 2025" width="240" height="240" className="h-12 w-auto object-contain" loading="lazy" />
        </div>
      </div>
    </footer>;
};